import { render, staticRenderFns } from "./loading-small.vue?vue&type=template&id=00bfae8a"
import script from "./loading-small.vue?vue&type=script&lang=js"
export * from "./loading-small.vue?vue&type=script&lang=js"
import style0 from "./loading-small.vue?vue&type=style&index=0&id=00bfae8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports